module.exports = __webpack_public_path__ + "static/scale-model-of-bush-house-museum-in-salem-oregon-6160218c9e36197d4a383fc7b18f058d.png";